export const theme = {
  colors: {
    primary: '#4F46E5',
    primaryDark: '#4338CA',
    primarySoft: '#EEF2FF',
    accent: '#06B6D4',
    accentSoft: '#ECFEFF',
    ink: '#0F172A',
    body: '#475569',
    muted: '#94A3B8',
    border: '#E2E8F0',
    surface: '#FFFFFF',
    surfaceAlt: '#F8FAFC',
    footerBg: '#0F172A',
    footerLine: 'rgba(255,255,255,0.1)',
    footerText: 'rgba(255,255,255,0.72)',
    footerMuted: 'rgba(255,255,255,0.55)',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
  },
  font: {
    family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  radius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    pill: '999px',
  },
  shadow: {
    sm: '0 1px 2px rgba(15,23,42,0.06)',
    md: '0 4px 12px rgba(15,23,42,0.08)',
    lg: '0 12px 32px rgba(15,23,42,0.10)',
    glow: '0 8px 24px rgba(79,70,229,0.25)',
  },
  maxWidth: '1200px',
  gradient: {
    primary: 'linear-gradient(135deg, #4F46E5 0%, #06B6D4 100%)',
    soft: 'linear-gradient(135deg, #EEF2FF 0%, #ECFEFF 100%)',
    dark: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
  },
};

export default theme;
